/* global $ */
import React, { Component } from 'react';
import { Button, Form } from 'semantic-ui-react';
import { config } from './config.js';

class Login extends Component {
    componentDidMount() {
        var self = this;
        $('#loginForm')
            .form({
                fields: {
                    customerID: {
                        identifier: 'customerID',
                        rules: [
                            {
                                type   : 'empty',
                                prompt : 'Please enter your Customer ID'
                            }
                        ]
                    },
                    portalName: {
                        identifier: 'portalName',
                        rules: [
                            {
                                type   : 'empty',
                                prompt : 'Please enter a Portal name'
                            }
                        ]
                    },
                    username: {
                        identifier: 'username',
                        rules: [
                            {
                                type   : 'empty',
                                prompt : 'Please enter your Username'
                            }
                        ]
                    },
                    password: {
                        identifier: 'password',
                        rules: [
                            {
                                type   : 'empty',
                                prompt : 'Please select your Password'
                            }
                        ]
                    }
                },
                onSuccess: function (e) {
                    e.preventDefault();
                    self.handleClick(e)
                }
            })
        ;
    }

    handleClick(event) {
        var self = this;
        var portalName = self.refs.portalName.value;
        $.ajax({
              async: true,
              crossDomain: true,
              url: config.accountServiceUrl + '/oauth2/token',
              method: 'POST',
              headers: {
                  "accept-encoding": "application/json",
                  "content-type": "application/x-www-form-urlencoded"
              },
              data: {
                  "client_id": this.refs.username.value,
                  "client_secret": this.refs.password.value,
                  "grant_type": "client_credentials"
              },
              success: function(response) {
                      $.ajax({
                        url: config.accountServiceUrl + '/accounts',
                        method: 'GET',
                        dataType: 'json',
                        crossDomain: true,
                        cache: false,
                        beforeSend: function(request) {
                            request.setRequestHeader("Authorization", "Bearer " + response.access_token);
                          },
                            success: function(data) {

                                    /** Get ID of Customer ID **/
                                    $.ajax({
                                        url: config.accountServiceUrl + '/accounts/?identifier=' + self.refs.customerID.value,
                                        method: 'GET',
                                        dataType: 'json',
                                        crossDomain: true,
                                        cache: false,
                                        beforeSend: function(request) {
                                            request.setRequestHeader("Authorization", "Bearer " + response.access_token);
                                        },
                                        success: function(customer_data) {

                                            if (customer_data.items[0] != undefined) {
                                                self.accountId = customer_data.items[0].id;
                                            }
                                            else {
                                              $('.ui.error.message').text("Customer ID not found");
                                              $('#loginForm').removeClass("success").addClass("error");
                                            }
                                            /** End of Get ID of Customer ID **/
                                            $.ajax({
                                                url: config.captivePortalServiceUrl + '/captive-portals?account-scope='+ config.accountServiceUrl + '/accounts/' +
                                                    self.accountId + '&name=' + self.refs.portalName.value,
                                                method: 'GET',
                                                dataType: 'json',
                                                crossDomain: true,
                                                cache:false,
                                                beforeSend: function(request){
                                                    request.setRequestHeader("Authorization", "Bearer " + response.access_token);
                                                },
                                                success: function(data) {
                                                    let exist = data.items.some( item => item['name'] === portalName );
                                                    if (data.items.size == 0 || !exist) {
                                                        $('.ui.error.message').text("Portal does not exist in account");
                                                        $('#loginForm').removeClass("success").addClass("error");
                                                    } else {
                                                      self.portalId = data.items[0].id;
                                                    }
                                                    self.props.setAdmin(true);
                                                    self.props.showApp(response.access_token, self.accountId, response.expires_in, true, self.portalId);
                                                    $.ajax({
                                                            url: config.cbuServiceUrl + '/customer/' + self.accountId +'/'+ self.portalId + '/settings',
                                                            method: 'GET',
                                                            dataType: 'json',
                                                            crossDomain: true,
                                                            cache: false,
                                                            beforeSend: function(request) {
                                                                request.setRequestHeader("Authorization", "Bearer " + response.access_token);
                                                            },
                                                            success: function(data) {
                                                                self.props.setVradiusServerId(data.vRadiusServerId);
                                                                self.props.setBusinessName(data.businessName);
                                                                sessionStorage.setItem('isLoggedOut', "false");
                                                                self.props.history.push('/');
                                                            }.bind(this),
                                                            error: function(xhr, status, err) {
                                                                console.error(self.props.url, status, err.toString());
                                                                if (xhr.status === 500) {
                                                                    $('.ui.error.message').text(xhr.responseJSON.message);
                                                                    $('#loginForm').removeClass("success").addClass("error");
                                                                }
                                                            }.bind(this)
                                                        });
                                                  }.bind(this),
                                                        error: function(xhr, status, err) {
                                                            console.error(self.props.url, status, err.toString());
                                                            if (xhr.status === 500) {
                                                                $('.ui.error.message').text(xhr.responseJSON.message);
                                                                $('#loginForm').removeClass("success").addClass("error");
                                                            }
                                                        }.bind(this)
                                              });
                                            }.bind(this)
                                        });
                                    },
                                    error(xhr, status, err) {
                                        console.error(self.props.url, status, err.toString());
                                        if (xhr.status === 401) {
                                            $('.ui.error.message').text("The username or password you entered has not been recognised");
                                            $('#loginForm').removeClass("success").addClass("error");
                                        }
                              }
                      });


              }
            });
    }

    render() {
        return (
            <div>
                <header id="loginHeader">
                    <div id="gradient"></div>
                    <a href="/">proximus</a>
                </header>
                <Form id="loginForm">
                    <Form.Field>
                        <input type="text" name="customerID" ref="customerID" placeholder="Customer ID" />
                    </Form.Field>
                    <Form.Field>
                        <input type="text" name="portalName" ref="portalName" placeholder="Portal Name" />
                    </Form.Field>
                    <Form.Field>
                        <input type="email" name="username" ref="username" placeholder="Username" />
                    </Form.Field>
                    <Form.Field>
                        <input type="password" name="password" ref="password"
                               placeholder="Password" />
                    </Form.Field>
                    <div className="ui error message"></div>
                    <Button className="primary submit">Submit</Button>
                </Form>
            </div>
        );
    }
}
export default Login;



// WEBPACK FOOTER //
// ./src/Login.jsx